import React, {Fragment, useEffect, useMemo, useRef, useState} from "react";
import {
  AppBar, Box, Button, CircularProgress,
  Dialog, DialogActions,
  DialogContent, DialogContentText,
  DialogTitle, IconButton, Menu, MenuItem, Select,
  TextField, Toolbar,
} from "@mui/material";
import {Redirect, Route, Switch, useHistory, useLocation} from "react-router-dom";
import cookie from "react-cookies";
import ProductSearchBar from "./ProductSearchBar";
import {
  FULL_SEARCH_BAR_TRIGGER_WIDTH,
  MIN_WIDTH_THRESHOLD,
  MOBILE_WIDTH_THRESHOLD,
  RECEIVER_COOKIE_KEY
} from "../constant";
import {
  AccountCircle,
  AddBoxOutlined,
  AddShoppingCartRounded,
  History,
  ListOutlined
} from "@mui/icons-material";
import {useUserState} from "../UserContext";
import ArrivalView from "./ArrivalView";
import RegisterView from "./RegisterView";
import ArrivalHistoryView from "./ArrivalHistoryView";
import ProductManage from "./ProductManage";
import {getProducts, useProductsDispatch} from "../ProductsContext";
import axios from "axios";
import useWindowDimensions from "../Dimension";
import {useSnackbar} from "notistack";
import {useWarehouseState} from "../WarehouseContext";
import {getWarehouseColor} from "../stringutils";
import styled from "@emotion/styled";



// const useStyles = makeStyles((theme) => ({
//   // layout: {
//   //   width: '100%',
//   //   left: '0px',
//   // },
//   // root: {
//   //   // flex: 1,
//   //   height: '100%',
//   //   margin: theme.spacing(1),
//   //   display: 'flex',
//   //   flexDirection: 'column',
//   // },
//   // header: {
//   //   // flex: 1,
//   //   display: 'flex',
//   //   flexDirection: 'row',
//   //   // justifyItems: 'center',
//   //   justifyItems: 'center',
//   //   flexBasis: 1,
//   //   // flexGrow: 1,
//   // },
//   // main: {
//   //   paddingTop: theme.spacing(1),
//   //   paddingBottom : theme.spacing(3),
//   //   width: '100%',
//   //   height : '100%',
//   // },
//   // main_message: {
//   //   display: 'flex',
//   //   width: '100%',
//   //   flexDirection: 'column',
//   //   justifyContent: 'center',
//   //   alignItems: 'center',
//   // },
//   // message: {
//   //   display: 'flex',
//   //   marginTop: theme.spacing(18),
//   //   flexDirection: 'column',
//   //   justifyContent: 'center',
//   //   width: '100%',
//   //   justifyItems: 'center',
//   //   flexBasis: 1,
//   //   flexGrow: 1,
//   // },
//   // header_left: {
//   //   // flex: 1,
//   //   display: 'flex',
//   //   flexDirection: 'row',
//   //   flexBasis: 1,
//   //   flexGrow: 1,
//   //   justifyContent: 'flex-start'
//   //   // flexShrink: 2,
//   // },
//   // header_right: {
//   //   // flex: 1,
//   //   marginLeft: theme.spacing(2),
//   //   display: 'flex',
//   //   flexDirection: 'row',
//   //   // flexBasis: 1,
//   //   // flexGrow: 1,
//   //   justifyContent: 'flex-end'
//   //   // flexShrink: 2,
//   // },
//   // first_button: {
//   //   paddingTop : theme.spacing(1.8),
//   //   paddingBottom : theme.spacing(1.8),
//   // },
//   // button: {
//   //   paddingTop : theme.spacing(1.8),
//   //   paddingBottom : theme.spacing(1.8),
//   //   marginLeft: theme.spacing(1),
//   // },
//   // username: {
//   //   padding: theme.spacing(2),
//   //   marginBottom: theme.spacing(2),
//   //   backgroundColor: "#1e88e588",
//   //   color: "white"
//   // },
//   // layout_progress: {
//   //   marginTop: theme.spacing(18),
//   //   display: 'flex',
//   //   flexDirection: 'column',
//   //   alignItems: 'center'
//   // },
//   // dialog_content: {
//   //   display: 'flex',
//   //   flexDirection: 'column',
//   //   width: 320,
//   // },
// }));

export const StyledButton = styled(Button)(({ theme }) => ({
  paddingTop : theme.spacing(1.8),
  paddingBottom : theme.spacing(1.8),
  marginLeft: theme.spacing(0.3),
}));

// const button = {
//   paddingTop : (theme) => theme.spacing(1.8),
//   paddingBottom : (theme) => theme.spacing(1.8),
//   marginLeft: (theme) => theme.spacing(1),
// }


export default function Main(props){

  const history = useHistory()
  const location = useLocation()
  const { windowHeight, windowWidth } = useWindowDimensions();
  const warehouseState = useWarehouseState()
  const productDispatch = useProductsDispatch()
  // const [result, setResult] = useState('')
  const [requesting, setRequesting] = useState(false)
  const [openErrorDialog, setOpenErrorDialog] = useState(false)
  const [dialogMessage, setDialogMessage] = useState("")
  const [errorMessage, setErrorMessage] = useState("")
  const [products, setProducts] = useState([])
  const [selected, setSelected] = useState(null)
  const [fullSearchBar, setFullSearchBar] = useState(false)
  const [dialog, setDialog] = useState({
    open : false,
    title : '',
    message : '',
    type : 0,
    showPosButton : true,
    posButtonText : '예',
    negButtonText : '아니요',
  })
  const [showCenterSelectDialog, setShowCenterSelectDialog] = useState(false)

  // const [snackbar, setSnackbar] = useState({
  //   open : false,
  //   message : '',
  // })

  const [newBarcode, setNewBarcode] = useState(null)
  const [centerId, setCenterId] = useState('')
  const [historySearchScope, setHistorySearchScope] = useState(null)
  const idleTimerRef = useRef(null)
  const [showIdleDialog, setShowIdleDialog] = useState(false)

  const [anchorEl, setAnchorEl] = useState(null);
  const [pwdManage, setPwdManage] = useState({
    open : false,
    pwd : "",
    pwdConfirm : "",
    error : false,
    errorMessage : '',
    confirmError : false,
    confirmErrorMessage : '',
  })

  // const style = useStyles()
  const userState = useUserState()
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  // useEffect(()=>{
  //   if(props.location.state != null){
  //     // if(props.location.state.snackbar != null){
  //     //   setSnackbar({
  //     //     open: true,
  //     //     message: props.location.state.snackbar,
  //     //   })
  //     //   console.log('reset snack bar')
  //     //   history.replace('/',  null)
  //     // }
  //
  //     console.log(props.location.state)
  //   }
  //
  //   return () => {
  //     console.log('main useEffect for state cleanup')
  //   }
  // }, []);

  useEffect(()=>{
    if(centerId === ''){
      setShowCenterSelectDialog(true)
    }

  }, [])

  useEffect(() => {
    if (location.pathname !== '/data/manage') {
      clearTimeout(idleTimerRef.current)
      setShowIdleDialog(false)
      return
    }

    const IDLE_MS = 5 * 60 * 1000

    const resetTimer = () => {
      clearTimeout(idleTimerRef.current)
      idleTimerRef.current = setTimeout(() => setShowIdleDialog(true), IDLE_MS)
    }

    const events = ['mousemove', 'keydown', 'mousedown', 'touchstart', 'scroll']
    events.forEach(e => window.addEventListener(e, resetTimer))
    resetTimer()

    return () => {
      events.forEach(e => window.removeEventListener(e, resetTimer))
      clearTimeout(idleTimerRef.current)
    }
  }, [location.pathname])

  const showRegisterView = () => {
    setProducts([])
    history.push('/data/register');
  }

  const logout = () => {
    console.log('logout ')
    cookie.remove(RECEIVER_COOKIE_KEY)
    history.replace('/signin')
  }

  const handleClickPositive = () => {
    if(dialog.type === 0){
      logout()
    }
  }

  const handleWarehouseChange = (event) => {
    setCenterId(event.target.value)
  }

  const selectCenter = () =>
    <Select
      value={centerId}
      onChange={handleWarehouseChange}
      displayEmpty
      style={{
        marginRight: 6,
        width : MIN_WIDTH_THRESHOLD > windowWidth ? 70 : 100,
        backgroundColor : getWarehouseColor(centerId, warehouseState.data.results),
        color : "#ffffff",
        fontSize : 15,
      }}
      variant="outlined"
    >
      <MenuItem value={null} disabled>

      </MenuItem>
      {warehouseState.data ?
        warehouseState.data.results.map((warehouse)=> <MenuItem key={warehouse.id} value={warehouse.id} sx={{fontSize : 15}}>{warehouse.name + '입고'}</MenuItem>)
        :
        <div/>
      }


    </Select>

  const productSearchBar = useMemo(() =>
    <ProductSearchBar
        filterMode={location.pathname === '/data/manage' || location.pathname === '/data/history'}
        optionsOverride={location.pathname === '/data/history' ? historySearchScope : null}
        onCleared={()=>{
          console.log('onCleared ', products)
          setProducts([])
          if(location.pathname === '/data/history'){
            setHistorySearchScope(historySearchScope) // keep current scope on clear
          }
        }}
        selected={selected}
        onKeyUp={(e) => enqueueSnackbar("키눌림 " + e.key, {variant : 'success'})}
        onFocus={()=>{
          console.log('windowWidth ' + windowWidth)
          if(windowWidth < FULL_SEARCH_BAR_TRIGGER_WIDTH) {
            setFullSearchBar(true)
          }
        }}
        onBlur={()=>{
          setFullSearchBar(false)
        }}
        onSelected={(value)=>{
          console.log('onSelected', location.pathname, value)
          if(location.pathname === '/data/history') {
            console.log('setProducts ', products)
            let filtered = products.filter(item => item.id !== value.id)
            setProducts([...filtered, value])
            setSelected({
              name: ''
            })
          }else if(location.pathname === '/data/register' || location.pathname === '/data/manage'){
            setSelected({
              name: ''
            })
            setProducts([value])
          }else if(location.pathname === '/data/recv'){
            setProducts([value])
          }
        }}
        onFiltered={(value)=> {
          // console.log('onFiltered', location.pathname)
          if(location.pathname === '/data/manage' || location.pathname === '/data/history') {
            setProducts(value)
          }

        }}
      />, [location.pathname, selected, historySearchScope])

  const gotoRecv = () => {
    setProducts([])
    setSelected({
      name : ''
    })
    history.push('/data/recv')
  }

  const recvButton = () =>
    windowWidth > MIN_WIDTH_THRESHOLD ?
      <Button
        startIcon={<AddShoppingCartRounded/>}
        onClick={()=>gotoRecv()}
        sx={{
          paddingTop : (theme) => theme.spacing(1.8),
          paddingBottom : (theme) => theme.spacing(1.8),
        }}
        color={(location.pathname === '/data/recv') ? 'primary' : 'neutral'}
        variant={(location.pathname === '/data/recv') ? 'contained' : 'outlined'}>
        입고하기
      </Button>
      :
      <Button
        onClick={()=>gotoRecv()}
        sx={{
          paddingTop : (theme) => theme.spacing(1.8),
          paddingBottom : (theme) => theme.spacing(1.8),
        }}
        color={(location.pathname === '/data/recv') ? 'primary' : 'neutral'}
        variant={(location.pathname === '/data/recv') ? 'contained' : 'outlined'}>

        <AddShoppingCartRounded/>
      </Button>

    // <Button
    //   startIcon={<AddShoppingCartRounded/>}
    //   onClick={()=>{
    //     setProducts([])
    //     setSelected({
    //       name : ''
    //     })
    //     history.push('/data/recv')
    //   }}
    //   sx={{
    //     paddingTop : (theme) => theme.spacing(1.8),
    //     paddingBottom : (theme) => theme.spacing(1.8),
    //   }}
    //   color={(location.pathname === '/data/recv') ? 'primary' : 'neutral'}
    //   variant={(location.pathname === '/data/recv') ? 'contained' : 'outlined'}>
    //   {windowWidth > MOBILE_WIDTH_THRESHOLD ? '입고하기' : ''}
    // </Button>


  const gotoHistory = () => {
    setProducts([])
    setSelected({
      name : ''
    })
    setHistorySearchScope(null)
    localStorage.removeItem(`lastStartDateFilter`)
    localStorage.removeItem(`lastEndDateFilter`)
    localStorage.removeItem(`lastDateFilterName`)
    history.push('/data/history')
  }

  const historyButton = () =>
    windowWidth > MIN_WIDTH_THRESHOLD ?
      <StyledButton
        startIcon={<History/>}
        onClick={()=>gotoHistory()}
        color={(location.pathname === '/data/history') ? 'primary' : 'neutral'}
        variant={(location.pathname === '/data/history') ? 'contained' : 'outlined'}>
        입고내역
      </StyledButton>
      :
      <StyledButton
        onClick={()=>gotoHistory()}
        color={(location.pathname === '/data/history') ? 'primary' : 'neutral'}
        variant={(location.pathname === '/data/history') ? 'contained' : 'outlined'}>
        <History sx={{ p : 0}}/>
      </StyledButton>

  const registerButton = () =>
    windowWidth > MIN_WIDTH_THRESHOLD ?
     <StyledButton
      startIcon={<AddBoxOutlined/>}
      onClick={()=>showRegisterView()}
      // className={style.button}
      color={(location.pathname === '/data/register') ? 'primary' : 'neutral'}
      variant={(location.pathname === '/data/register') ? 'contained' : 'outlined'}>
      바코드 등록
    </StyledButton>
      :
    <StyledButton
      onClick={()=>showRegisterView()}
      color={(location.pathname === '/data/register') ? 'primary' : 'neutral'}
      variant={(location.pathname === '/data/register') ? 'contained' : 'outlined'}>
      <AddBoxOutlined/>
    </StyledButton>

  const gotoManage = () => {
    setProducts([])
    setSelected({
      name : ''
    })
    getProducts(productDispatch, centerId)
    history.push('/data/manage')
  }

  const manageButton = () =>
    windowWidth > MIN_WIDTH_THRESHOLD ?
    <StyledButton
      startIcon={<ListOutlined/>}
      onClick={()=> gotoManage()}
      // className={style.button}
      color={(location.pathname === '/data/manage') ? 'primary' : 'neutral'}
      variant={(location.pathname === '/data/manage') ? 'contained' : 'outlined'}>
      상품관리
    </StyledButton>
    :
     <StyledButton
      onClick={()=> gotoManage()}
      // className={style.button}
      color={(location.pathname === '/data/manage') ? 'primary' : 'neutral'}
      variant={(location.pathname === '/data/manage') ? 'contained' : 'outlined'}>
      <ListOutlined/>
    </StyledButton>

  const accountButton = () =>
      <StyledButton
        id="accountButton"
        // className={style.button}
        onClick={handleMenu}
        color={"inherit"}
        variant="outlined">
          <AccountCircle/>
        {windowWidth > MIN_WIDTH_THRESHOLD ? <span>{userState.data ? userState.data.results.name : ''}</span> : <div/>}
      </StyledButton>



  const menuClose = () => {
    setAnchorEl(null);
  };

  const handleMenu = (event) => {
    // console.log('handleMenu ' , event.currentTarget)
    setAnchorEl(event.currentTarget);
  };

  const onPassKeyPress = (e) => {
    if(e.key === 'Enter'){
      console.log('onPassKeyPress Enter ' ,e)
      changePassword()
    }
  }

  const closePwdManage = () => {
    setPwdManage({...pwdManage, open : false, warn : false})
  }

  const changePassword = () => {
    console.log('changePassword')

    if(!Boolean(pwdManage.pwd)) {
      setPwdManage({
        ...pwdManage,
        error: true, errorMessage: "패스워드를 입력하세요",
        confirmError: false, confirmErrorMessage: ""
      })
      return;
    }else if(pwdManage.pwd.length < 6) {
      setPwdManage({
        ...pwdManage,
        error: true, errorMessage: "패스워드는 6자리 이상이어야 합니다.",
        confirmError: false, confirmErrorMessage: ""
      })
      return;
    }else if(!Boolean(pwdManage.pwdConfirm)){
      setPwdManage({
        ...pwdManage,
        error: false, errorMessage: "",
        confirmError: true, confirmErrorMessage: "패스워드를 입력하세요"
      })
      return;
    }else if(pwdManage.pwdConfirm !== pwdManage.pwd){
      setPwdManage({
        ...pwdManage,
        error: false, errorMessage: '',
        confirmError : true, confirmErrorMessage: "패스워드가 일치하지 않습니다."
      })
      return;
    }

    closePwdManage()
    setRequesting(true)

    axios.post(`${process.env.REACT_APP_API_HOST}/user/info/changepw`, {
      params: {
        token: cookie.load(RECEIVER_COOKIE_KEY),
        pwd: pwdManage.pwd
      }
    }).then((resp) => {
      if(resp.status === 200 && resp.data != null && resp.data['code'] === 200) {

        enqueueSnackbar("패스워드를 업데이트 했습니다.", {variant : 'success'})
      }

      setRequesting(false)
    }).catch((e)=>{
      setRequesting(false)
      // setSnackbar({
      //   open: true,
      //   message: "패스워드를 업데이트를 실패 했습니다."
      // })
      enqueueSnackbar("패스워드를 업데이트 실패 했습니다.", {variant : 'error'})
    })
  }

  return (
    <Box sx={{width : '100%', left: '0px'}}>
      {
        requesting ?
          <Box sx={{
              mt: (theme) => theme.spacing(18),
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
          }}>
            <CircularProgress size={34} thickness={4}/>
          </Box>
          :
           <Box sx={{
              height: '100%',
              margin: (theme) => theme.spacing(1),
              display: 'flex',
              flexDirection: 'column'
           }}>
             <AppBar position="fixed" color={'inherit'}>
               <Toolbar sx={{p : 0,}}>
                 {
                   windowWidth > MOBILE_WIDTH_THRESHOLD ?
                     <Fragment>
                      <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexBasis: 1,
                        flexGrow: 1,
                        justifyContent: 'flex-start'
                      }}>
                        {
                          !fullSearchBar ?
                            selectCenter()
                            :
                            <div/>
                        }
                        {productSearchBar}
                      </Box>
                       {
                        !fullSearchBar ?
                          <Box sx={{
                            // flex: 1,
                            marginLeft: (theme) => theme.spacing(2),
                            display: 'flex',
                            flexDirection: 'row',
                            // flexBasis: 1,
                            // flexGrow: 1,
                            justifyContent: 'flex-end'
                            // flexShrink: 2,
                          }}>
                            {recvButton()}
                            {historyButton()}
                            {registerButton()}
                            {manageButton()}
                            {accountButton()}
                          </Box>
                         :
                          <div/>
                       }
                     </Fragment>
                     :
                     <Box sx={{width : '100%',}}>
                      <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexBasis: 1,
                        flexGrow: 1,
                        width : '100%',
                        justifyContent: 'center'
                      }}>

                        {productSearchBar}
                      </Box>
                      <Box sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexBasis: 1,
                        flexGrow: 1,
                        width : '100%',
                        justifyContent: 'center'
                      }}>
                        {selectCenter()}
                        {recvButton()}
                        {historyButton()}
                        {registerButton()}
                        {manageButton()}
                        {accountButton()}
                      </Box>
                     </Box>
                 }
                 <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    open={Boolean(anchorEl)}
                    onClose={menuClose}
                  >
                  <MenuItem onClick={()=>{
                    setAnchorEl(null)
                    setPwdManage({
                      open : true,
                      pwd: '',
                      pwdConfirm: '',
                      error: false,
                      errorMessage: ''
                    })
                  }}>
                    패스워드변경
                  </MenuItem>
                  <MenuItem
                    onClick={()=>{
                      menuClose()
                      setDialog({
                          ...dialog,
                          open: true,
                          message: "로그아웃하시겠습니까?"
                        })
                    }}>
                    {`로그아웃`}
                  </MenuItem>
                </Menu>
               </Toolbar>
             </AppBar>
             <Box sx={{
                paddingTop: (theme) => theme.spacing(1),
                paddingBottom : (theme) => theme.spacing(3),
                width: '100%',
                height : '100%',
             }}>
               {
                 windowWidth > MOBILE_WIDTH_THRESHOLD ?
                   <Toolbar/>
                   :
                   <Fragment>
                      <Toolbar/>
                      <Toolbar/>
                   </Fragment>
               }

                <Switch>
                  <Route path='/data' exact component={()=>{
                    console.log('redirect to recv')
                    return <Redirect to={"/data/recv"}/>
                  }}/>
                  <Route path='/data/recv'
                         render={() =>
                           <ArrivalView
                             centerId={centerId}
                             products={products}
                             onSelected={(value)=>{
                               // setProducts([value])
                               setSelected(value)
                             }}
                             onNewBarcode={(value)=>{
                                setSelected({
                                  name: ''
                                })
                                setNewBarcode(value)
                                showRegisterView()
                             }}
                           />
                         }
                  />
                  <Route
                    path='/data/register'
                    render={() =>
                      <RegisterView products={products} barcode={newBarcode}/>
                    }
                  />
                  <Route path='/data/history'
                         render={() =>
                            <ArrivalHistoryView
                              products={products}
                              onUpdateSearchScope={(opts)=> setHistorySearchScope(opts)}
                              onDeleteFilter={(value)=>{
                                console.log('onDeleteFilter', value)
                                setProducts(products.filter(item => item.id !== value.id))
                                setSelected({
                                  name: ''
                                })
                              }}
                               onSelected={(value)=>{
                                  let filtered = products.filter(item => item.id !== value.id)
                                  setProducts([...filtered, value])
                                  setSelected({
                                    name: ''
                                  })
                               }}
                               onNewBarcode={(value)=>{
                                  setSelected({
                                    name: ''
                                  })
                                  setNewBarcode(value)
                                  showRegisterView()
                               }}
                            />
                         }
                  />
                  <Route path='/data/manage'
                         render={() =>
                            <ProductManage
                              products={products}
                              onSelected={(value)=>{
                               // setProducts([value])
                               setSelected(value)
                             }}
                             onNewBarcode={(value)=>{
                               setSelected({
                                  name: ''
                                })
                                setNewBarcode(value)
                                showRegisterView()
                             }}
                            />
                         }
                  />
              </Switch>
              </Box>

            </Box>
      }
      <Dialog
        open={openErrorDialog}
        onClose={()=>setOpenErrorDialog(false)}
      >
        <DialogTitle id="alert-dialog-title">{"오류발생"}</DialogTitle>

        <DialogContent aria-multiline={true}>
          <div>{dialogMessage}</div>
          <div>{errorMessage}</div>

        </DialogContent>
        <DialogActions>
          <Button onClick={()=>setOpenErrorDialog(false)} color="primary">
            닫기
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={dialog.open}
        onClose={()=>{setDialog({ ...dialog, open : false, message: '', errorMessage: ''})
        }}
      >
        <DialogTitle id="alert-dialog-title">{dialog.title}</DialogTitle>

        <DialogContent sx={{
          display: 'flex',
          flexDirection: 'column',
          width: 320,
        }} aria-multiline={true}>
          <div>{dialog.message}</div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={()=>{
              setDialog({
                ...dialog,
                open : false
              })
            }} color="secondary">
            {dialog.negButtonText}
          </Button>
          {
            dialog.showPosButton ?
              <Button
                onClick={()=>{handleClickPositive()}}
                color="primary">
                {dialog.posButtonText}
              </Button>
              :
              <div/>
          }

        </DialogActions>
      </Dialog>
      <Dialog
        open={showCenterSelectDialog}
      >
        <DialogTitle id="alert-dialog-title">{dialog.title}</DialogTitle>

        <DialogContent aria-multiline={true}>
          <div>입고를 진행할 창고를 선택하세요</div>
          <div style={{marginTop : 24, width : '100%', display : 'flex', justifyContent : 'center'}}>
            {/*{selectCenter()}*/}
            {warehouseState.data ?
              warehouseState.data.results.map((warehouse)=>
                <Button
                  onClick={() => {
                    setCenterId(warehouse.id)
                    setShowCenterSelectDialog(false)
                  }}
                  variant={"contained"}
                  style={{
                    backgroundColor : getWarehouseColor(warehouse.id, warehouseState.data.results),
                    width : 140,
                    height : 70,
                    marginLeft : 18,
                    fontSize : 18
                  }}
                  key={warehouse.id}
                  value={warehouse.id}
                  sx={{fontSize : 15}}>
                  {warehouse.name}
                </Button>
              )
            :
            <div/>
          }
          </div>
        </DialogContent>
        {/*<DialogActions>*/}
        {/*  <Button*/}
        {/*    disabled={centerId === null || centerId === ''}*/}
        {/*    onClick={()=>{*/}
        {/*      setShowCenterSelectDialog(false)*/}
        {/*    }} color="primary">*/}
        {/*    확인*/}
        {/*  </Button>*/}
        {/*</DialogActions>*/}
      </Dialog>
      <Dialog open={showIdleDialog} onClose={() => setShowIdleDialog(false)}>
        <DialogTitle>상품 목록 새로고침</DialogTitle>
        <DialogContent>
          <DialogContentText>
            일정시간동안 움직임이 감지되지 않았습니다. 새로고침을 눌러주세요.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setShowIdleDialog(false)
              getProducts(productDispatch, centerId)
            }}
          >
            새로고침
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={pwdManage.open}
        onClose={()=>closePwdManage()}
      >
        <DialogContent>
          <DialogContentText>
            패스워드 변경
          </DialogContentText>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginTop: 4,
              paddingBottom : 50
            }}
          >

            <TextField
              // margin={"dense"}
              onKeyPress={(e)=>onPassKeyPress(e)}
              label={'패스워드'}
              defaultValue={pwdManage.pwd}
              value={pwdManage.pwd}
              onChange={(event)=>{
                pwdManage.pwd = event.target.value
                if(pwdManage.error && Boolean(pwdManage.pwd)){
                  pwdManage.error = false
                  pwdManage.errorMessage = ''
                }
                setPwdManage({
                  ...pwdManage,
                })
              }}
              type={"password"}
              variant="outlined"
              error={pwdManage.error}
              helperText={pwdManage.errorMessage}
            />
            <TextField
              onKeyPress={(e)=>onPassKeyPress(e)}
              // margin={"dense"}
              style={{marginTop : 16}}
              label={'패스워드확인'}
              defaultValue={pwdManage.pwdConfirm}
              value={pwdManage.pwdConfirm}
              onChange={(event)=>{
                pwdManage.pwdConfirm = event.target.value
                if(pwdManage.confirmError && Boolean(pwdManage.pwdConfirm)){
                  pwdManage.confirmError = false
                  pwdManage.confirmErrorMessage = ''
                }
                setPwdManage({
                  ...pwdManage,
                })
                // checkCardSaveAvailable(cardManage)
              }}
              type={"password"}
              variant="outlined"
              error={pwdManage.confirmError}
              helperText={pwdManage.confirmErrorMessage}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            variant={"outlined"}
            onClick={()=>closePwdManage()}
          >
            취소
          </Button>
          <Button
            variant={"contained"}
            color={'primary'}
            onClick={()=>changePassword()}
          >
            변경
          </Button>
        </DialogActions>
      </Dialog>
     {/*<Snackbar*/}
     {/* open={snackbar.open}*/}
     {/* autoHideDuration={2000}*/}
     {/* onClose={()=>setSnackbar({open : false, message: ''})}*/}
     {/* message={snackbar.message}*/}
     {/* />*/}
    </Box>

  )
}

